import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CNH } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { GerarRenachIntegradoRequest, Types } from './types';

// ACTIONS
import {
	gerarRenachIntegradoSuccess,
	gerarRenachIntegradoFailure,
} from './actions';

function* gerarRenachIntegrado(request: ReducerAction) {
	const { payload }: { payload: GerarRenachIntegradoRequest } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CNH,
		`renach-integrado/${CHANNEL}/gerar-cadastro`,
		payload,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(gerarRenachIntegradoSuccess({ response, request: payload }));
	} else if (response.error) {
		yield put(gerarRenachIntegradoFailure({ response, request: payload }));
	}
}

export default all([
	takeLatest(Types.GERAR_RENACH_INTEGRADO_REQUEST, gerarRenachIntegrado),
]);
